module.exports = __webpack_public_path__ + "img/sidepanel-selectlist-not-selected.431b0ecb.svg";